import React, { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
} from '@mui/material'
import logo from '../../assets/images/logomobioh.png'
import CryptoJS from 'crypto-js'
import UserService from '../../service/UserService'
import { toast, ToastContainer } from 'react-toastify'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logar } from '../../redux/actions'
import * as S from './styles'
import {
  Lock,
  PersonOutline,
  Visibility,
  VisibilityOff,
} from '@mui/icons-material'
import { BannerLogin } from '../../components'
import RecuperarSenha from './RecuperarSenha'
import Types from '../../utilities/enums/Types'
import banner1 from '../../assets/images/banner/banner-login-2023-12-21-1.webp'
//import banner2 from '../../assets/images/banner/banner-mobioh-4.png'
import bannerR3 from '../../assets/images/banner/banner-alies.jpeg'
import logoR3 from '../../assets/images/R3Suprimentos.png'

function Login(props) {
  const [showPassword, setShowPassword] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [loadingSwitch, setLoadingSwitch] = React.useState(true)
  const [login, setLogin] = React.useState('')
  const [isLogin, setIsLogin] = React.useState(false)
  const [isPassword, setIsPassword] = React.useState(false)
  const [password, setPassword] = React.useState('')
  const [isRecuperarSenha, setIsRecuperarSenha] = React.useState(false)
  const [empresa, setEmpresa] = React.useState({
    titulo: Types.APP.tituloMobioh,
    logo: logo,
    rodape: `${Types.APP.mobioh} - ${Types.APP.version}`,
    banner: Types.APP.banner ,
  })

  const history = useHistory()

  const handleClickShowPassword = () => setShowPassword((show) => !show)
  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  async function handleLogin() {
    let senha = CryptoJS.MD5(password).toString()
    let newUser = {
      login,
      senha,
      ip: '',
      localizacao: '',
    }

    if (login.trim() === '') {
      setIsLogin(true)
      return
    }

    if (password.trim() === '') {
      setIsPassword(true)
      return
    }

    setLoading(true)
    await UserService.authentication(newUser)
      .then((data) => {
        setLoading(false)
        if (data.statusUsuario) {
          props.logar(true, data)
          sessionStorage.setItem('auth', JSON.stringify(data))
          toast.success('Autenticado com Sucesso!', {
            theme: 'colored',
          })
          history.push('/empresas')
        } else {
          toast.error('Falha na autenticação! Usuário ou senha inválidos', {
            theme: 'colored',
          })
          console.log('Falha na autenticação! Usuário ou senha inválidos')
        }
      })
      .catch((error) => {
        setLoading(false)
        if (error.message === 'Network Error') {
          toast.error('Falha na conexão com o servidor' + error.message, {
            theme: 'colored',
          })
          console.log('Falha na conexão com o servidor')
        }
      })
  }

  function empresasSwitch() {
    let origin = window.location.origin
    let objEmpresa = {
      titulo: Types.APP.tituloMobioh,
      logo: logo,
      rodape: `${Types.APP.mobioh} - ${Types.APP.version}`,
    }

    switch (origin) {

      case Types.AXBI.url:
        document.title = Types.APP.tituloAxbi
        objEmpresa = {
          titulo: Types.APP.tituloAxbi,
          logo: Types.AXBI.logo,
          rodape: `${Types.AXBI.rodape} - ${Types.APP.version}`,
          banner: Types.AXBI.banner,
        }
        break

      case Types.INFINITE.url:
        document.title = Types.INFINITE.titulo
        objEmpresa = {
          titulo: Types.INFINITE.titulo,
          logo: Types.INFINITE.logo,
          rodape: `${Types.INFINITE.rodape} - ${Types.APP.version}`,
          banner: Types.INFINITE.banner,
        }
        break

      case Types.R3_SUPRIMENTOS.url:
        document.title = Types.R3_SUPRIMENTOS.titulo
        objEmpresa = {
          titulo: Types.R3_SUPRIMENTOS.titulo,
          logo: logoR3,
          rodape: `${Types.R3_SUPRIMENTOS.rodape} - ${Types.APP.version}`,
          banner: bannerR3,
        }
        break

      default:
        document.title = Types.APP.tituloMobioh
        objEmpresa = {
          titulo: Types.APP.tituloMobioh,
          logo: logo,
          rodape: `${Types.APP.mobioh} - ${Types.APP.version}`,
          banner: Types.APP.banner,
        }
        break
    }

    // Simulando um atraso de 2 segundos (2000ms)
    const timeout = setTimeout(() => {
      setEmpresa(objEmpresa)
      setLoadingSwitch(false)
    }, 2000)

    return () => clearTimeout(timeout)
  }

  useEffect(() => {
    empresasSwitch()
  }, [])

  return (
    <S.Container>
      <ToastContainer />
      {loadingSwitch && (
        <caption style={{ textAlign: 'center' }}>
          <LinearProgress sx={{ width: '80vw' }} />
        </caption>
      )}
      {!loadingSwitch && (
        <Grid
          container
          sx={{
            minWidth: { xs: 'auto', md: 'auto', lg: '100vw' },
            minHeight: { xs: 'auto', md: 'auto', lg: '100vh' },
            bgcolor: '#FFF',
          }}
        >
          <Grid
            xs={12}
            md={6}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
              mb: { xs: 0, md: 0, lg: 0 }, // aplica margin-top 4 (equivale a 32px) apenas no mobile
            }}
          >
            {!isRecuperarSenha && (
              <S.BoxLogin>
                <S.Image src={empresa.logo} />

                <S.Title>{empresa.titulo}</S.Title>
                <S.Divider />

                <S.StyledTextField
                  placeholder="Informe seu login"
                  size="medium"
                  onChange={(e) => {
                    setIsLogin(false)
                    setLogin(e.target.value)
                  }}
                  error={isLogin}
                  helperText={isLogin ? 'Essa informação é obrigatória' : ''}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonOutline fontSize="small" />
                      </InputAdornment>
                    ),
                  }}
                />
                <S.StyledTextField
                  placeholder="Informe sua senha"
                  type={showPassword ? 'text' : 'password'}
                  onChange={(e) => {
                    setIsPassword(false)
                    setPassword(e.target.value)
                  }}
                  error={isPassword}
                  helperText={isPassword ? 'Essa informação é obrigatória' : ''}
                  size="medium"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Lock fontSize="small" />
                      </InputAdornment>
                    ),

                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? (
                            <VisibilityOff fontSize="small" />
                          ) : (
                            <Visibility fontSize="small" />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Button
                  className="confirm-button"
                  variant="contained"
                  size="small"
                  endIcon={
                    loading && <CircularProgress color="inherit" size={25} />
                  }
                  disabled={loading}
                  sx={{ height: '43px', width: '85%', marginTop: '25px' }}
                  onClick={handleLogin}
                >
                  Entrar
                </Button>

                <Button
                  className="confirm-button"
                  variant="text"
                  size="small"
                  // endIcon={
                  //   loading && <CircularProgress color="inherit" size={25} />
                  // }
                  disabled={loading}
                  sx={{
                    height: '20px',
                    fontWeight: 'bold',
                    width: '85%',
                    marginTop: '15px',
                    textTransform: 'initial',
                  }}
                  onClick={() => setIsRecuperarSenha(true)}
                >
                  Esqueci minha senha
                </Button>
              </S.BoxLogin>
            )}

            {isRecuperarSenha && (
              <S.BoxLogin>
                <S.Image src={empresa.logo} />

                <S.Title>{empresa.titulo}</S.Title>
                <S.Divider />
                <RecuperarSenha setIsRecuperarSenha={setIsRecuperarSenha} />
              </S.BoxLogin>
            )}

            <caption
              style={{
                fontSize: '12px',
                position: 'absolute',
                bottom: '30px',
              }}
            >
              {empresa.rodape}
            </caption>
          </Grid>
          <Grid
            xs={12}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: { xs: 'center', md: 'center', lg: 'flex-end' },
              alignItems: { xs: 'center', md: 'center', lg: 'flex-end' },
            }}
          >
            <BannerLogin bannerEmpresa={empresa.banner} />
          </Grid>
        </Grid>
      )}
    </S.Container>
  )
}

const mapStateToProps = (store) => ({
  loggedIn: store.loginState.loggedIn,
  idUser: store.loginState.idUser,
  idFilial: store.loginState.idFilial,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({ logar }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Login)
